module.exports = __webpack_public_path__ + "static/media/Yellow.a91aa836.mp4";